<script setup>
import { computed } from 'vue';
import LogoLight from './LogoLight.vue';
import { useCustomizerStore } from '@/shared/stores/customizer';
import LogoDark from './LogoDark.vue';

const customizer = useCustomizerStore();
</script>
<template>
    <LogoDark/>
</template>
